export default __webpack_public_path__ + "static/media/medium-hover.41565b9a.svg";